import ApiHelper from '../ApiHelper.js';

const PortfoliosApiUrl = "/api/portfolio/";
const PortfolioTemplatesApiUrl = "/api/portfolio-template/"

function updateImageFromBlob(url, blob, fileName, path, filesToDelete) {
    const data = new FormData();
    data.append('imageFile', blob, fileName);
    data.append('path', path);
    data.append('filesToDelete', filesToDelete)
    return ApiHelper.postMultipart(url, data);
}

export default {
    moveDomainToPortfolio: function(domainName, targetPortfolioId) {
        return ApiHelper.post(`${PortfoliosApiUrl}moveDomain/${targetPortfolioId}/${domainName}`);
    },
    
    getPortfolio: function (portfolioId) {
        return ApiHelper.get(PortfoliosApiUrl + portfolioId);
    },

    getPortfolioByShortId: function (portfolioShortId) {
        return ApiHelper.get(`${PortfoliosApiUrl}shortid/${portfolioShortId}`);
    },

    getPortfolios: function (ownerId) {
        return ApiHelper.get(`${PortfoliosApiUrl}getByUserId/`  + ownerId);
    },

    refreshManagerPreviews: function (ownerId) {
        return ApiHelper.post(`${PortfoliosApiUrl}${ownerId}/manager-previews`);
    },

    refreshManagerPreview: function (ownerId, portfolioId) {
        return ApiHelper.post(`${PortfoliosApiUrl}${ownerId}/manager-previews/${portfolioId}`);
    },

    createPortfolio: function (userId, portfolio, projects) {
        return ApiHelper.post(PortfoliosApiUrl + userId, {portfolio, projects});
    },

    duplicatePortfolio: function (userId, portfolio, portfolioTitle) {
        return ApiHelper.post(`${PortfoliosApiUrl}duplicate/` + userId, {portfolio, portfolioTitle});
    },

    editPortfolio: function (portfolio) {
        return ApiHelper.put(PortfoliosApiUrl, portfolio);
    },

    addDefaultPortfolioPages(portfolio) {
        return ApiHelper.put(`${PortfoliosApiUrl}addDefaultPages`, portfolio)
    },

    deletePortfolio: function (portfolioId) {
        return ApiHelper.delete(PortfoliosApiUrl + portfolioId);
    },

    getPortfolioTemplateSettings(portfolioId) {
        return ApiHelper.get(`${PortfoliosApiUrl}${portfolioId}/template-settings`)
    },

    getPortfolioTemplatePreview(portfolioId) {
        return ApiHelper.get(`${PortfolioTemplatesApiUrl}${portfolioId}/preview`)
    },

    getTemplatePreviews() {
        return ApiHelper.get(`${PortfolioTemplatesApiUrl}preview`)
    },

    getTemplateStyle(portfolioShortId) {
        return ApiHelper.get(`${PortfolioTemplatesApiUrl}${portfolioShortId}/style`)
    },

    getPortfolioTemplateAndSettings(portfolioId) {
        return ApiHelper.get(`${PortfoliosApiUrl}${portfolioId}/template-design-settings`)
    },

    getPortfolioSettings(portfolioId) {
        return ApiHelper.get(`${PortfoliosApiUrl}${portfolioId}/settings`)
    },

    setPortfolioSettings(portfolioId, settings) {
        return ApiHelper.put(`${PortfoliosApiUrl}${portfolioId}/settings`, settings)
    },

    setPortfolioPassword: function (portfolioId, password) {
        return ApiHelper.put(PortfoliosApiUrl + portfolioId + "/password", {password: password});
    },

    setPortfolioDraft: function (portfolioId, draft) {
        return ApiHelper.put(PortfoliosApiUrl + portfolioId + "/draft", {draft: draft});
    },

    deletePortfolioImage(portfolio, imageUrl, options = {}) {
        return ApiHelper.delete("/api/image/portfolio/delete/" + portfolio, imageUrl, options);
    },

    setDomainForPortfolio: function(portfolioId, domain) {
        return ApiHelper.post(PortfoliosApiUrl + "domain/" + portfolioId + "/" + domain);
    },

    updatePortfolioUrl: function (portfolioId, urlSlug) {
        return ApiHelper.put(PortfoliosApiUrl + "updateUrl/" + portfolioId + "/" + urlSlug);
    },

    uploadCroppedImage: function (userId, portfolioId, blob, extension, imageToDelete) {
        return updateImageFromBlob("/api/image/portfolio/upload/" + portfolioId, blob, 'croppedImage.' + extension, userId + "/portfolios/" + portfolioId, [imageToDelete]);
    },

    updatePortfolioLegacyLogo(logo,portfolioId) {
        return ApiHelper.put(`${PortfoliosApiUrl}updateLogo/${portfolioId}`, logo)
    },

    updatePortfolioLogo(logo, portfolioId) {
        return ApiHelper.put(`${PortfoliosApiUrl}${portfolioId}/logo`, logo)
    },

    updatePortfolioNavigation(navigation, portfolioId) {
        return ApiHelper.put(`${PortfoliosApiUrl}${portfolioId}/navigation`, navigation)
    },

    updatePortfolioHero(hero, portfolioId) {
        return ApiHelper.put(`${PortfoliosApiUrl}${portfolioId}/hero`, hero)
    },

    updatePortfolioDesignSettings(designSettings, portfolioId) {
        return ApiHelper.put(`${PortfoliosApiUrl}${portfolioId}/design-settings`, designSettings)
    },

    updatePortfolioCursorType(cursorType, portfolioId) {
        return ApiHelper.put(`${PortfoliosApiUrl}${portfolioId}/cursor-type`, {cursorType})
    },

    setPortfolioGlobalSpacing(project) {
        return ApiHelper.put(`${PortfoliosApiUrl}setGlobalSpacing`, project)
    }
}
